import { Component, Input, OnInit } from '@angular/core';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-card-notif-expired',
  templateUrl: './card-notif-expired.component.html',
  styleUrls: ['./card-notif-expired.component.scss'],
})
export class CardNotifExpiredComponent implements OnInit {
  @Input() date: string;
  @Input() days: number;
  @Input() textTitle = 'PO akan kedaluwarsa pada:';
  @Input() cardClasses = 'mt-8';

  STRING_CONSTANTS = STRING_CONSTANTS;
  isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor() {}

  ngOnInit(): void {
    this.isLoading.next(false);
  }
}
